import React, { useEffect, useState, useRef } from "react";

import { auth, firebase } from "../../Firebase/config";

import {
  onSnapshot,
  orderBy,
  limit,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  FieldValue,
  getCountFromServer,
} from "@firebase/firestore";

import axios from "axios";

import {
  Link,
  Route,
  Routes,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import "../Messages.css";

export default function Phonelessstudents({
  currentclass,
  activename,
  setSelectedclass,
  activeid2,
  activename2,
  selectedclass,
  currentstudent,
  setCurrentstudent,
  studentidd,
  parentlanguagecode,
  id2,
  temparray,
  databaseactivename,
  activeid,
  id,
  role, 
  assignmentname,
}) {

  const [lasttwomonths, setlasttwomonths] = useState([]);

  const [searchingstate, setSearchingstate] = useState(false);
  const [aallpasses, setAallpasses] = useState();

  const [filteredstates, setFilteredstates] = useState([]);

  const [activpasses, setActivpasses] = useState([]);
  const [update, setUpdate] = useState();

  const [changehasbeenmade, setChangehasbeenmade] = useState();
  const [endtime, setEndtime] = useState();
  const [begintime, setBegintime] = useState();

  const [revise, setRevise] = useState();

  const [passesbetween, setPassesbetween] = useState();

  const [currentclass2, setCurrentclass2] = useState();
  const [activeid22, setActiveid2] = useState();

  const [website, setWebsite] = useState();
  const [whatparentssee, setWhatpareentseee] = useState();
  const [thispage, setThispage] = useState();

  const navigate = useNavigate();

  

  const selectHandler = (value, i) => {

    if (value && activeid2 != value.id) {
  
      setSelectedclass(value);
    } else {
      setSelectedclass("");
    }

  };

  useEffect(() => {
setThispage(window.location.href)

  }, []);


  async function getstudentsfromgc() {
    if (typeof activeid2 != "undefined") {

      updateDoc(doc(firebase, "classesbeingtaught", activeid), {
        googleclassroomid: activeid2,
        googleclassroomname: activename2,
      }).catch((error) => {
        console.log(error); alert(error);
      })


      async function waitForLocalStorageItems(keys) {
        return new Promise((resolve) => {
          const interval = setInterval(() => {
            const allItemsPresent = keys.every((key) => localStorage.getItem(key) !== null);
            if (allItemsPresent) {
              clearInterval(interval);
              resolve();
            }
          }, 100); // Check every 100ms
        });
      }
  
      await waitForLocalStorageItems(["refresh_token", "access_token", "expiry_date"]);
  
  
      const refreshToken = localStorage.getItem("refresh_token");
      const accessToken = localStorage.getItem("access_token");
      const expiryDate = localStorage.getItem("expiry_date");



        const API_BASE_URL = "https://api-hkshnm7duq-uc.a.run.app";
        const currentUrl = window.location.href;
         // Get the current URL

        const isProduction = process.env.NODE_ENV === "production";
        const baseUrl = isProduction ? "https://fastclasspass.web.app" : "http://localhost:3000";
        const redirectUrl = `${baseUrl}/role/${role}/mainmenu/id/${id}/gcstudents`;
        
        try {
          const stateParam = JSON.stringify({
            id: id,
            currentUrl: currentUrl,
            task: "fetchStudents",
            redirectUrl: redirectUrl,
            courseId: activeid2,
            databasecourseId: activeid,
          });
          const response = await fetch(`${API_BASE_URL}/api/login?state=${encodeURIComponent(stateParam)}`, { method: "GET" });
          const finalUrl = response.url || "";
          if (!finalUrl.startsWith(API_BASE_URL)) {
            window.location.href = `${redirectUrl}?id=${id}&dataStoredInDatabase=true`;
            return;
          }
          const data = await response.json();
          console.log("Auth URL:", data.authUrl);
          if (data.authUrl) {
            window.location.href = data.authUrl;
          } else {
            console.error("Auth URL not received from the server.");
            alert("Failed to retrieve the authentication URL.");
          }
        } catch (error) {
          console.error("Error during login:", error.message);
          alert("Failed to initiate login. Please check the console for details.");
        }
    }
  }

  return (
    <div className="inner123">
      {typeof temparray != "undefined" ? (
        <>
         {typeof assignmentname != "undefined" ? <div className="centerme2951">{assignmentname}<br />(Classroom Assignment) </div> : <div className="centerme2951">Google Classroom <br />Assignment</div> }
          {temparray.map((item, index) => (
            // Add a unique key prop to the outermost element returned by map
            <React.Fragment key={item.id || index}>
              {typeof activeid2 == "undefined" ? (
                <div onClick={() => selectHandler(item, index)}>
                  <div
                    className={item.id == activeid2 ? "passstart2" : "passstart"}
                  >
                    <div onClick={() => console.log("select")}>
                      {item.name} <br></br>
                      {item.grade}
                    </div>
                    <div></div>
                  </div>
                </div>
              ) : typeof activeid2 != "undefined" &&
                activeid2 != item.id ? null : (
                <div>
                  <div
                    className={item.id == activeid2 ? "passstart2" : "passstart"} onClick={() => selectHandler(item, index)}
                  >
                    <div onClick={() => console.log("select")}>
                      {item.name} <br></br>
                      {item.grade}
                    </div>
                    <div></div>
                  </div>
                  <br></br>
                </div>
              )}
            </React.Fragment>
          ))}
        </>
      ) : null}
      <br></br>
    </div>
  );
}

/* <View>
<div
  style={
    item.id === idselected ? styles.selected : styles.unselected
  }
  onClick={() => selectHandler(item)}>
  <div style={styles.end}>{item.firstname} {item.lastname}{'\n'}{new Date(item.leftclass).toString().substr(4, 11)} @ {item.timeleftclass}{'\n'}{item.comingfrom} -{item.destination} - {item.timeallowedonpass} min.</div>
</div>


</View> */
